import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roofing-installation")({
  beforeLoad: () => {
    throw redirect({ to: "/services/roof-replacement", statusCode: 301 });
  },
});
